import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Loader from "components/Loader";

import { replaceSegmentsFromRoutes } from "helpers/replaceSegmentsFromRoutes";
import { useGetEntityParams } from "hooks/useGetEntityParams";

import { RouteType } from "types";

interface RedirectRouteProps {
  route: RouteType;
  children: ReactNode;
}

const RedirectRoute = ({ route, children }: RedirectRouteProps) => {
  const navigate = useNavigate();
  const entityParams = useGetEntityParams();
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (entityParams === undefined) return;
    if (!route.redirect) {
      return setBusy(false);
    }

    setBusy(true);
    const timeout = setTimeout(() => {
      let routeToRedirect = route.redirect || "";
      if (entityParams.length) {
        const routeData = entityParams.reduce(
          (data: { params: string[]; replacer: string[] }, entity) => {
            return {
              params: [...data.params, entity.key],
              replacer: [...data.replacer, entity.value],
            };
          },
          {
            params: [],
            replacer: [],
          }
        );

        routeToRedirect = replaceSegmentsFromRoutes({
          params: routeData.params,
          replacer: routeData.replacer,
          route: route.redirect || "",
        });
      }

      navigate(routeToRedirect, { replace: true });
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [navigate, entityParams, route.redirect]);

  if (busy) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default RedirectRoute;
